import styled from 'styled-components';
import { deviceBreakpoints, variables } from 'variables';

export const PassSC = styled.div`
  background: ${(props) => props.theme.pageBackgroundColor};
  width: 100%;
  border-bottom: 4px solid ${(props) => props.theme.primaryDarkColor};
  padding: ${variables.pageContentPadding}px;
  padding-top: 60px;
  padding-bottom: 2em;
  @media only screen and (max-width: ${deviceBreakpoints.mobile}px) {
    padding: ${variables.pageContentPadding}px;
  }
`;

export const ChangePasswords = styled.div`
  margin-top: 20px;
  margin-bottom: 40px;
`;

export const FormDiv = styled.div`
  padding-bottom: 2.4em;
`;
